import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';

export type JTableBodyProps = {
  /** Table is sortable */
  sortable: boolean;
  /** Sorting handler */
  onSortEnd?: () => void;
  /** Children */
  children?: React.ReactNode;
};

const SortableBox = SortableContainer((props: any) => <tbody {...props} />);

/**
 * Sostituisce il body della tabella in caso di sorting drag&drop
 * */
export const JTableBody = ({
  sortable = false,
  onSortEnd,
  ...otherProps
}: JTableBodyProps) => {
  if (sortable) {
    return (
      <SortableBox
        useDragHandle
        disableAutoscroll
        helperClass="row-dragging"
        onSortEnd={onSortEnd}
        {...otherProps}
      />
    );
  }

  return <tbody {...otherProps} />;
};
